import * as React from 'react'
import './SettingsPanel.css'
import { SettingsData } from '../../model/Settings'

import JSONPretty from 'react-json-pretty'
const JSONPrettyMon = require('react-json-pretty/dist/monikai')

export interface SettingsPanelProps {
    data: SettingsData;
    changed: any;
}

export interface SettingsPanelState {
    settingsText: string;
    mode: 'view' | 'edit';
}

export default class SettingsPanel extends React.Component<SettingsPanelProps, SettingsPanelState> {
  constructor (props: SettingsPanelProps) {
    super(props)
    let settingsText: string = ''
    try {
      settingsText = JSON.stringify(this.props.data, null, 2)
    } catch (error) {
      console.log(error)
    }
    this.state = {
      settingsText: settingsText,
      mode: 'view'
    }
  }

  UNSAFE_componentWillReceiveProps (nextProps: SettingsPanelProps) {
    if (nextProps !== this.props) {
      let settingsText: string = ''
      try {
        settingsText = JSON.stringify(nextProps.data, null, 2)
        this.setState({
          settingsText: settingsText
        })
      } catch (error) {
        console.log(error)
      }
    }
  }

    public onBlur = (event: any) => {
      if (this.props.changed) {
        let settingsData: SettingsData | undefined
        try {
          settingsData = JSON.parse(this.state.settingsText)
        } catch (error) {
          console.log(error)
        }
        if (settingsData) {
          this.props.changed(settingsData)
        }
      }
      this.setState({
        mode: 'view'
      })
    }

    onClick = (event: any) => {
      this.setState({
        mode: 'edit'
      })
    }

    public onChange = (event: any) => {
      const nativeEvent: any = event.nativeEvent
      const stateObject: any = {
      }
      const propertyName: string = nativeEvent.target.name
      stateObject[propertyName] = nativeEvent.target.value
      this.setState(stateObject)
    }

    render () {
      let settings: any
      if (this.state.mode === 'view') {
        settings = <JSONPretty data={this.state.settingsText} theme={JSONPrettyMon} />
      } else {
        settings = <textarea name="settingsText" id="settingsText" rows={30} value={this.state.settingsText} onChange={this.onChange} onBlur={this.onBlur} />
      }
      return <div id="settingsPanelContainer" className="container" >
            <label className="settingsPanelHeader">Settings</label>
            <div id='settingsDataContainer' onClick={this.onClick}>
                {settings}
            </div>
        </div>
    }
}
